import { useLocation } from 'react-router';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbSeparator,
} from '@/components/ui/Breadcrumb';
import { useAuth } from '@/context/auth';
import {toCapitalizeCase} from '@/util/misc';

export function DynamicBreadcrumbs() {
  const { user } = useAuth();
  const { pathname } = useLocation();

  const pathArray = pathname.split('/').filter(Boolean);

  const basePathMap: Record<string, string> = {
    dashboard: 'Dashboard',
    fileupload: 'File Upload',
    agents: 'Agents',
  };
  const name = user?.name ?? 'Agent Profile';
  const userPathMap: Record<string, string> = user
    ? {[user?.username as string]: name}
    : {};

  const pathMap: Record<string, string> = {
    ...basePathMap,
    ...userPathMap,
  };

  const breadcrumbs = pathArray.map((segment, index) => {
    const href = `/${pathArray.slice(0, index + 1).join('/')}`;
    const isLast = index === pathArray.length - 1;
    const label = pathMap[segment] || segment;
    const disableLinkSegments = ['agents'];
    const disableLink =
      disableLinkSegments.includes(segment) && pathArray.length > index + 1;
    const formattedLabel = toCapitalizeCase(decodeURIComponent(label), '-');

    return (
      <BreadcrumbItem key={href}>
        {isLast || disableLink ? (
          <BreadcrumbLink>{formattedLabel}</BreadcrumbLink>
        ) : (
          <BreadcrumbLink className="capitalize" href={href}>
            {formattedLabel}
          </BreadcrumbLink>
        )}
        {!isLast && <BreadcrumbSeparator />}{' '}
      </BreadcrumbItem>
    );
  });

  return (
    <Breadcrumb>
      <BreadcrumbList>{breadcrumbs}</BreadcrumbList>
    </Breadcrumb>
  );
}
